module.exports = __webpack_public_path__ + "static/21-674f71492039e6c2c7e7062c66b7bb95.jpg";